import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../lib/auth/useAuth'
import useAxios from '../../lib/auth/useAxios'

function OTPHandler({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const auth = useAuth() // Access your auth context
  const axios = useAxios()

  useEffect(() => {
    // Parse URL parameters
    const queryParams = new URLSearchParams(location.search)
    const otpToken = queryParams.get('otp')

    // Check if OTP is present
    if (otpToken) {
      handleOTPLogin(otpToken, location.pathname)
    }
  }, [location])

  const handleOTPLogin = async (otpToken, originalPath) => {
    try {
      // Create an axios instance using your existing useAxios hook
      // This ensures it gets the same interceptors and configuration

      // Call your Django backend to validate OTP
      const response = await axios.post('main/auth/otp-login/', {
        token: otpToken,
      })

      if (response && response.data) {
        // Store tokens using the same pattern as your existing auth
        if (response.data.token) {
          localStorage.setItem('access_token', response.data.token)
        }
        if (response.data.refresh) {
          localStorage.setItem('refresh_token', response.data.refresh)
        }

        // Set logged in state
        localStorage.setItem('is_logged_in', true)

        // Update user data if available
        if (response.data.user) {
          auth.setUser(response.data.user)

          // If you have access to the dispatch function within this component,
          // update Redux state as well, similar to your loggedInVerify function
          // This would require passing dispatch as a prop or using useDispatch here
        }

        // Navigate to the original URL but remove the OTP parameter
        navigate(originalPath, { replace: true })
      }
    } catch (error) {
      console.error('OTP login failed:', error)
      // You might want to redirect to login page or show an error message
      // based on your application's flow
    }
  }

  return children
}

export default OTPHandler
